import React, { useState, useEffect,useContext } from 'react'
import { collection, query, orderBy, onSnapshot, doc, getDoc } from "firebase/firestore"
import { app, database, auth, storage } from '../../../firebaseConfig'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, IconButton, ButtonGroup } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../AuthProvider';
import AccessDinied from '../../../components/AccessDinied';
function Utilisateur() {
    const {user}=useContext(AuthContext)
    const navigate = useNavigate()
    const [showModal, setShowModal] = useState(false)
    const [users, setUsers] = useState([])
    useEffect(() => {
        const q = query(collection(database, 'utilisateur'), orderBy('nom', 'asc'))
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const usersData = querySnapshot.docs.map(async (userDoc) => {
                const userData = userDoc.data()
                const chuId = userData.chu_id
                userData.nom_chu = ''
                if (chuId) {
                    const chuDocRef = doc(database, 'chu', chuId);
                    const chuSnapshot = await getDoc(chuDocRef);
                    userData.nom_chu = chuSnapshot.data().nom_chu
                }
                
                
                return {
                    id: userDoc.id,
                    ...userData
                }
            })
            Promise.all(usersData).then((modifiedUsers) => {
                console.log(modifiedUsers)
                setUsers(modifiedUsers)
            });
        })
        return () => unsubscribe();

    }, [])

    if(user.type !='Admin'){
        return <AccessDinied/>
    }
    return (
        <div style={{ width: '100%', flexGrow: 1, overflow: 'hidden' }}>
            <Button variant="contained" size='small' onClick={() => {
                navigate('/admin/addUser')
            }} startIcon={<AddCircleOutlineIcon />}>
                Ajouter
            </Button>
            <DataGrid rowSelection={false}
                columns={[
                    { field: 'user_uid', headerName: 'UID', minWidth: 350 },
                    { field: 'nom', headerName: 'Nom', minWidth: 200 },
                    { field: 'nom_chu', headerName: 'Chu', minWidth: 150 },
                    { field: 'type', headerName: 'Rôle', minWidth: 150 },
                    // {
                    //     field: 'actions',
                    //     type: 'actions',
                    //     headerName: 'Actions',
                    //     minWidth: 50,
                    //     cellClassName: 'actions',
                    //     getActions: ({ id }) => {
                    //         return [
                    //             <GridActionsCellItem icon={<EditIcon />}
                    //                 label="Edit"
                    //                 sx={{
                    //                     color: 'primary.main',
                    //                 }}
                    //                 onClick={() => {
                    //                     console.log(users)
                    //                 }} />,
                    //             <GridActionsCellItem icon={<DeleteIcon />}
                    //                 label="Edit"
                    //                 sx={{
                    //                     color: 'error.main',
                    //                 }}
                    //                 onClick={() => {
                    //                     alert(id)
                    //                 }} />
                    //         ]
                    //     }
                    // }
                ]}
                rows={users}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 5,
                        },
                    },
                }}
                pageSizeOptions={[5]}
                sx={{ marginTop: 2 }}
            />

        </div>
    )
}

export default Utilisateur